module.exports = __webpack_public_path__ + "img/screen-endorsements.ad51b24f.png";